import React, { FC, Fragment, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { Divider } from '@material-ui/core';

import { useProtectedClient } from 'hooks';
import { Capability } from 'components';
import { UserSegmentFragment } from 'api';

import Message from './Message';
import Content from './Content';
import FormActions from './FormActions';
import Meta from './Meta';
import Recipients from './Recipients';
import When from './When';
import Title from './Title';

import { ContentEmailValues } from 'features/admin/types';

interface Props {
  updateCount: (count: number) => void;
  segments: UserSegmentFragment[];
  totalUserCount: number;
}

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(4),
  },
}));

const ContentEmailsForm: FC<Props> = ({ segments, updateCount, totalUserCount }) => {
  const classes = useStyles();
  const client = useProtectedClient();

  const {
    values: { segment_ids },
  } = useFormikContext<ContentEmailValues>();

  useEffect(() => {
    if (segment_ids.length) {
      if (!segments) {
        return null;
      }
      const totalNumPeople = segment_ids.reduce((numPeople, segmentId) => {
        const segment = segments.find(currentSegment => currentSegment.id === segmentId);
        if (!segment) {
          return numPeople;
        }
        return numPeople + segment.registered_count + segment.third_party_count;
      }, 0);

      updateCount(totalNumPeople);
      return null;
    }

    updateCount(totalUserCount);
  }, [segment_ids]);

  return (
    <Fragment>
      <Title />
      <Divider className={classes.divider} />

      <Recipients />
      <Divider className={classes.divider} />

      <When />
      <Divider className={classes.divider} />

      {!!client.email_sending_domain && (
        <Capability name="Admin.ContentEmails.Function.SenderSettings">
          <Meta edit />
          <Divider className={classes.divider} />
        </Capability>
      )}

      <Message />
      <Divider className={classes.divider} />

      <Content />
      <Divider className={classes.divider} />

      <FormActions />
    </Fragment>
  );
};

export default ContentEmailsForm;
